import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=1d93521f&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import "./Menu.vue?vue&type=style&index=0&id=1d93521f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d93521f",
  null
  
)

export default component.exports